import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import FileUploaderMulti from './FileUploaderMulti';
import FileUploaderSingle from "./FileUploaderSingle";
import { upload } from "@testing-library/user-event/dist/upload";

interface IFileUploaderModalForm {
  title: string | undefined;
  buttonTextChoose: string | undefined;
  buttonTextUpload: string | undefined;
  buttonTextMain: string | undefined;
  fileGroupId: number | undefined | null;
  fileGroup: string;
  newGroupOnUpload: boolean;
  multiUpload: boolean;
  onUploadSuccess(groupId: number): void;
}

export default function FileUploaderModalForm({ title, buttonTextChoose, buttonTextUpload, buttonTextMain, fileGroupId,
  fileGroup, newGroupOnUpload, multiUpload, onUploadSuccess }: IFileUploaderModalForm) {

  const [uploading, setUploading] = React.useState<boolean>(false);
  const [modal, setModal] = React.useState(false);
  const toggle = () => setModal(!modal);

  function onUploadSuccessFromModal(groupId: number) {
    setUploading(false);
    toggle();
    onUploadSuccess(groupId);
  }

  function uploadStarted() {
    setUploading(true);
  }

  function onUploadFail(groupId: number) {
    setUploading(false);
  }

  return (
    <React.Fragment>
      <button type="button" className="btn btn-primary btn-sm" onClick={toggle}>
        {buttonTextMain}
      </button>
      <Modal id="fileUploadModal" isOpen={modal} toggle={toggle} size="lg" fullscreen="xl" backdrop={true} scrollable={true}>
        <ModalHeader toggle={toggle}>
          <h5 className="modal-title">{title || (multiUpload ? "Upload Documents" : "Upload Document")}</h5>
        </ModalHeader>
        <ModalBody>
          {multiUpload && <FileUploaderMulti buttonTextChoose={buttonTextChoose} buttonTextUpload={buttonTextUpload}
            fileGroup={fileGroup} fileGroupId={fileGroupId} onUploadStart={uploadStarted} onUploadSuccess={onUploadSuccessFromModal} 
            onUploadFail={onUploadFail} newGroupOnUpload={newGroupOnUpload} />}
          {!multiUpload && <FileUploaderSingle buttonTextChoose={buttonTextChoose} buttonTextUpload={buttonTextUpload}
            fileGroup={fileGroup} fileGroupId={fileGroupId} onUploadStart={uploadStarted} onUploadSuccess={onUploadSuccessFromModal}
            onUploadFail={onUploadFail} newGroupOnUpload={newGroupOnUpload} />}
        </ModalBody>
        <ModalFooter>
          {!uploading && <button type="button" className="btn btn-primary" onClick={toggle}>Close</button>}
          {uploading && <Spinner color="primary" />}
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

